module.exports = __webpack_public_path__ + "img/montage-logo.68c5dd6c.png";